module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"tooltip":{"settings":"Configurações"}},"en-US":{"tooltip":{"settings":"Settings"}}}')
  delete Component.options._Ctor
}
